const OTHER_ANSWER_PREFIX = 'Other: ';

// Custom "other" answers are stored as "Other: {text}". The first message
// should read as the text the member typed.
const topicPhrase = (value) => {
  if (typeof value !== 'string') return '';

  const text = value.trim();
  if (text.startsWith(OTHER_ANSWER_PREFIX)) return text.slice(OTHER_ANSWER_PREFIX.length).trim();

  return text;
};

const topicsText = (topics) => {
  const phrases = topics.map((topic) => topic.toLowerCase());
  if (phrases.length <= 2) return phrases.join(' and ');

  return `${phrases.slice(0, -1).join(', ')} and ${phrases[phrases.length - 1]}`;
};

// Matches the hardcoded questionnaire handoff: a list answer (usually
// conversation topics) becomes "Hi {name}, I would like to chat about …".
export const buildMentorFirstMessage = (mentorName, answer) => {
  const name = typeof mentorName === 'string' ? mentorName.trim() : '';
  if (name === '') return '';

  const topics = (Array.isArray(answer) ? answer : [answer]).map(topicPhrase).filter((phrase) => phrase !== '');
  if (topics.length === 0) return '';

  return `Hi ${name}, I would like to chat about ${topicsText(topics)}`;
};
